import { observer } from 'mobx-react';
import GroupParticipantsStore from '../../Group/GroupParticipantsStore/Store';
import { GroupParticipantsResource } from '../../Group/GroupParticipantsStore/Types';
import ParticipantsAddedModal from './ParticipantsAddedModal';
import SelectParticipantsModal from './SelectParticipantsModal';
import AddParticipantStore from '../Store';

interface Props {
  store: AddParticipantStore;
  groupParticipantsResource: GroupParticipantsResource;
  groupParticipantsStore: GroupParticipantsStore;
}

function Modal({ store, groupParticipantsResource, groupParticipantsStore }: Props) {
  switch (store.state.kind) {
    case 'submitting':
    case 'ready':
    case 'new-participant':
    case 'remove-participant':
    case 'error':
      return (
        <SelectParticipantsModal
          modalStore={groupParticipantsStore.modalStore}
          store={store}
          groupParticipantsResource={groupParticipantsResource}
        />
      );
    case 'participants-added':
      return (
        <ParticipantsAddedModal
          store={store}
          groupParticipantsResource={groupParticipantsResource}
          groupParticipantsStore={groupParticipantsStore}
        />
      );
  }
}

export default observer(Modal);
